import React, { useCallback, useState } from 'react';
import { useDropzone, FileRejection } from 'react-dropzone';
import { Box, Tooltip, Typography } from '@mui/material';
import theme from "../../theme/theme";

interface FileUploadProps {
    onUpload: (file: File) => void;
    acceptedMimeTypes?: { [key: string]: string[] };
}

export const FileUpload: React.FC<FileUploadProps> = ({
                                                          onUpload,
                                                          acceptedMimeTypes = {
                                                              'text/csv': ['.csv'],
                                                              'application/pdf': ['.pdf'],
                                                              'text/plain': ['.txt'],
                                                          }
                                                      }) => {
    const [error, setError] = useState('');

    const onDrop = useCallback((acceptedFiles: File[]) => {
        setError('');
        acceptedFiles.forEach(file => onUpload(file));
    }, [onUpload]);

    const onDropRejected = useCallback((fileRejections: FileRejection[]) => {
        const errorMessages = fileRejections.flatMap(rejection =>
            rejection.errors.map(err => {
                if (err.code === 'file-invalid-type') {
                    return 'Ungültiger Dateityp. Bitte nur PDF, CSV oder TXT hochladen.';
                }
                return err.message;
            })
        );
        setError(errorMessages.join(' '));
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        accept: acceptedMimeTypes,
        onDrop,
        onDropRejected,
    });

    return (
        <Box p={2}>
            <Tooltip title="Erlaubte Dateiformate: PDF, CSV, TXT">
                <Box
                    {...getRootProps()}
                    sx={{
                        border: '2px dashed gray',
                        borderRadius: 4,
                        padding: 4,
                        textAlign: 'center',
                        backgroundColor: isDragActive ? 'action.hover' : 'background.paper',
                        cursor: 'pointer',
                    }}
                >
                    <input {...getInputProps()} />
                    {
                        isDragActive
                            ? <p>Dateien hier ablegen ...</p>
                            : <p>Dateien per Drag & Drop hier ablegen oder klicken, um Dateien auszuwählen</p>
                    }
                </Box>
            </Tooltip>
            {error && (
                <Typography color={theme.palette.error.main} fontSize="0.75rem" mt={1}>
                    {error}
                </Typography>
            )}
        </Box>
    );
};
